module.exports = __webpack_public_path__ + "resources/img/img_cloud_moa1_en.741e86bec164a67b9da7b2c022a64c0a.png";